import { IconType } from 'common/icons/types'

export type PrivateConsignedState = {
  privateConsigned: PrivateConsignedObject
} & PrivateConsignedActions

export interface PrivateConsignedObject {
  code: string
  contractedProduct: string
  productValue: string
  refundMethod: string
  productType: string
  terms: string
  manual: string
  coverages: {
    icon: IconType
    text: string
  }[]
  cancellation: PrivateConsignedCancellationFlow
  infoAlert?: string
}

export interface PrivateConsignedActions {
  setPrivateConsignedObject: (privateConsigned: PrivateConsignedObject) => void
  setPrivateConsignedCancellation: (cancellation: PrivateConsignedCancellationFlow) => void
  setPrivateConsignedCancellationReasonCode: (cancellationReasonCode: number) => void
  setPrivateConsignedCancellationReasons: (
    cancellationReasons: PrivateConsignedCancellationReason[],
  ) => void
  setPrivateConsignedCancellationTerms: (isTermsAndConditionsAccepted: boolean) => void
  setPrivateConsignedCancellationReceipt: (receipt: PrivateConsignedCancellationResponse) => void
  resetPrivateConsigned: () => void
}

export interface PrivateConsignedCancellationFlow {
  isTermsAndConditionsAccepted: boolean
  reasonCode: number
  reasons: PrivateConsignedCancellationReason[]
  receipt: PrivateConsignedCancellationResponse
  infoAlert?: string
}

export interface PrivateConsignedCancellationReason {
  codigo: number
  descricao: string
}

export interface PrivateConsignedCancellationResponse {
  status: string
  title: string
  subtitle: string
  titleInfoCancellation: string
  productName: string
  requestDate: string
  protocol: string
  refundValue: string
  cancellationDate?: string
  infoAlert?: string
}

export const INITIAL_STATE: PrivateConsignedObject = {
  code: '',
  contractedProduct: '',
  productValue: '',
  refundMethod: '',
  productType: '',
  terms: '',
  manual: '',
  coverages: [
    {
      icon: IconType.ADD,
      text: '',
    },
  ],
  cancellation: {
    isTermsAndConditionsAccepted: false,
    reasonCode: 0,
    reasons: [],
    receipt: {
      refundValue: '',
      status: '',
      title: '',
      subtitle: '',
      titleInfoCancellation: '',
      productName: '',
      requestDate: '',
      protocol: '',
      cancellationDate: '',
    },
  },
}
